import SocialField from "@/components/Common/forms/SocialField";
import clsxm from "@/lib/clsxm";
import HowDidYouHearAboutUs from "@/pages/registerCompany/steps/interestSelection/HowDidYouHearAboutUs";
import InterestSelection from "@/pages/registerCompany/steps/interestSelection/InterestSelection";
import useRegistrationStore from "@/store/registration";
import {type FC} from "react";
import {useTranslation} from "react-i18next";

const InterestSelectionStep: FC = () => {
  const {t} = useTranslation();
  const errors = useRegistrationStore(state => state.errors);
  const form = useRegistrationStore(state => state);
  const setError = useRegistrationStore(state => state.setError);
  const setValue = useRegistrationStore(state => state.setValue);

  return (
    <div className="flex w-full flex-col gap-5">
      <SocialField
        id="registration-company-instagram-username-field"
        dataTestId="registration-company-instagram-username-field"
        className={clsxm(!errors.companyInstagramUsername && "border-neutral-grey-light")}
        error={errors.companyInstagramUsername}
        label={t("companyInstagramUsername")}
        onChange={value => {
          setValue("companyInstagramUsername", value);
        }}
        setError={message => setError("companyInstagramUsername", message ?? "")}
        type="instagram"
        value={form.companyInstagramUsername}
      />
      <SocialField
        id="registration-company-tiktok-username-field"
        className={clsxm(!errors.companyTikTokUsername && "border-neutral-grey-light")}
        error={errors.companyTikTokUsername}
        label={t("companyTikTokUsername")}
        onChange={value => {
          setValue("companyTikTokUsername", value);

          if (!form.companyInstagramUsername) {
            setError("companyInstagramUsername", "");
          }
        }}
        setError={message => setError("companyTikTokUsername", message ?? "")}
        type="tiktok"
        value={form.companyTikTokUsername}
      />
      <InterestSelection />
      <HowDidYouHearAboutUs />
    </div>
  );
};

export default InterestSelectionStep;
